import type { FC } from 'react'

import Badge from '@/components/atoms/Badge'
import ConfigPreview from '@/components/molecules/ConfigPreview'
import { useScopedI18n } from '@/locales/client'
import type { Hub } from '@/services/schemas'
import { useMobileLayoutStore } from '@/stores/MobileLayoutStore'
import { cn } from '@/util/cn'
import { priceFormatter } from '@/util/formatter'

import { ShowPreviewButton } from '../atoms/ShowPreviewButton'

type HubOverviewProps = {
  hub: Hub
  hidden?: boolean
}

const HubOverview: FC<HubOverviewProps> = ({ hub, hidden }) => {
  const { isMobile, activeMobileTab } = useMobileLayoutStore()
  const t = useScopedI18n('hubOverview')
  const isKit = /kit/i.test(hub.name)

  return (
    <article className={cn(
      'flex flex-col items-center justify-between rounded-t-md bg-rsf-white rounded-b-md border-2 border-rsf-purple-light',
      hidden && 'hidden',
      isMobile && activeMobileTab === 'deluxe' && 'col-span-2',
    )}
    >
      <div className={cn('relative pt-1', isMobile && isKit && 'sm:w-60 h-min p-6 py-2')}>
        {hub.id && (
          <div className="p-1 sm:p-4" id={`config-preview-${hub.id}`}>
            <ConfigPreview className="config-grid-small size-full max-h-[116px] max-w-[94px] md:max-h-[236px] md:max-w-[234px]" hubId={hub.id} />
          </div>
        )}
      </div>

      <div className="flex h-full flex-col items-center justify-between gap-2 p-2 pt-0 md:gap-4">
        <div className="flex flex-col items-center">
          <h2 className="text-pretty text-center font-inter text-sm font-bold leading-tight text-black sm:text-base md:text-lg">
            {hub.name.replace(/kit/gi, '').replace('Reef', 'Reef ')}
          </h2>
          {isKit && (
            <div className="flex w-full justify-center">
              <Badge variant="kit" className="mt-1" style={{ padding: '3px 6px 5px 6px' }}>
                {t('kit')}
              </Badge>
            </div>
          )}
        </div>
        {hub.pricing.retailprice && (
          <span className="text-center text-xs font-bold tabular-nums text-rsf-grey-dark sm:text-sm md:text-base md:text-rsf-black">
            {priceFormatter(hub.pricing.retailprice, hub.pricing.currency)}
          </span>
        )}
      </div>
      <ShowPreviewButton hubId={hub.id} />
    </article>
  )
}

export default HubOverview
